import { Button, ButtonGroup } from '@chakra-ui/react';

interface EntraIdSettingsFooterProps {
  isLoading: boolean;
  isValid: boolean;
  isDirty: boolean;
  configurationVerified?: boolean;
  formEnabled?: boolean;
  onCancel: () => void;
  onSave: () => void;
  cancelLabel: string;
  saveLabel: string;
}

export const EntraIdSettingsFooter = ({
  isLoading,
  isValid,
  isDirty,
  configurationVerified,
  formEnabled,
  onCancel,
  onSave,
  cancelLabel,
  saveLabel,
}: EntraIdSettingsFooterProps) => {
  // Save disabled if:
  // 1. API is loading
  // 2. Form not modified
  // 3. Form invalid
  // 4. Enabled but connection not verified
  const saveDisabled =
    isLoading ||
    !isDirty ||
    !isValid ||
    (formEnabled && configurationVerified !== true);

  return (
    <ButtonGroup isDisabled={isLoading}>
      <Button variant="solid" colorScheme="gray" onClick={onCancel}>
        {cancelLabel}
      </Button>
      <Button
        variant="solid"
        onClick={onSave}
        isLoading={isLoading}
        isDisabled={saveDisabled}
      >
        {saveLabel}
      </Button>
    </ButtonGroup>
  );
};
